import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  PayloadSlaManagementType,
  SlaManagementDataType,
} from '../types/slaManagement.type'
const initialState: SlaManagementDataType = {
  data: [],
  totalPages: null,
  paginatedData: [],
}

const slaManagementSlice = createSlice({
  name: 'slaManagement',
  initialState: initialState,
  reducers: {
    getSlaListViewData: () => {
      return
    },
    updateSlaListViewState: (
      state,
      action: PayloadAction<SlaManagementDataType>
    ) => {
      state.data = action.payload.data
    },
    getSlaListViewPaginatedData: (
      _state,
      _action: PayloadAction<PayloadSlaManagementType>
    ) => {
      return
    },
    updateSlaListViewStateByPage: (state, action) => {
      state.paginatedData = action.payload.content
      state.totalPages = action.payload.totalPages
    },
  },
})

export const {
  getSlaListViewData,
  updateSlaListViewState,
  getSlaListViewPaginatedData,
  updateSlaListViewStateByPage,
} = slaManagementSlice.actions
export default slaManagementSlice.reducer
